export default {
  selectMonth: 'Select month',
  selectYearBE: 'Select year (B.E.)',
  selectYearAD: 'Select year (A.D.)',
  yearSuffix: 'A.D.',
  title: 'Select time range',
  from: 'From',
  to: 'to',
  selectNow: 'Current Date',
  date: 'Date',
  time: 'Time',
  now: 'Present',
  today: 'Today',
  yesterday: 'Yesterday',
  apply: 'Apply',
  cancel: 'Cancel',
  clear: 'Clear',
  reset: 'Reset',
  timezone: 'Time zone:',
  loading: 'Loading...',
  empty: 'No data',
  section: {
    this: 'This',
    last: 'Last',
  },
  placeholder: {
    from: 'Start date/time',
    to: 'End date/time',
    input: 'Select date range',
  },
  presets: {
    custom: 'Custom',
    today: 'Today',
    thisWeek: 'This week',
    thisMonth: 'This month',
    thisQuarter: 'This quarter',
    thisYear: 'This year',
    last1d: 'Yesterday',
    last7d: 'Last 7 days',
    last15d: 'Last 15 days',
    last30d: 'Last 30 days',
    last1q: 'Last 90 days',
    last1y: 'Last year',
  },
  relative: {
    lastXHours: 'Last {n} hours',
    lastXDays: 'Last {n} days',
    lastXWeeks: 'Last {n} weeks',
    lastXMonths: 'Last {n} months',
  },
  freq: {
    hourly: 'Hourly',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    yearly: 'Yearly',
  },
  units: {
    day: 'day(s)',
    week: 'week(s)',
    month: 'month(s),',
    quarter: 'quarter(s)',
    year: 'year(s)',
  },
  frequency: {
    every: 'Every',
    everyN: 'Every {n}',
    defaultDescription: 'Data frequency: The default setting for each chart is daily.',
    desc: 'Data display frequency: Every {n} {unit}.',
    startOnDay: 'starting on day {d}',
    ariaLabel: 'Frequency options',
    defaultTab: 'Default',
    onDayOfMonthPrefix: 'starting on day',
    onDayOfMonthSuffix: 'of the month',
    onWeekSuffix: 'week(s) (Sunday - Saturday)',
  },
};
